import { createFcmContext } from 'src/app/shared/contexts/fcm';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmContext: TopicPageFcmContext,
	FcmProvider: TopicPageFcmContextProvider,
	useFcm: useTopicPageFcm,
	useAsyncFcm: useAsyncTopicPageFcm,
	prefetchFcm: prefetchTopicPageFcm,
} = createFcmContext({
	name: 'TopicPageFcmContext',
	dataProperty: 'pageFcm',
	configs: {},
	prefetch: true,
});

export type TopicPageFcmState = ReturnType<typeof useAsyncTopicPageFcm>;
export type TopicPageFcm = LoadedStateData<TopicPageFcmState>;
